import { t } from "@/controllerLK/AvalLocalization";
import AnalyticsGeneral from "@/components/AnalyticsPage/AnalyticsGeneral.vue";
import AnalyticsReports from "@/components/AnalyticsPage/AnalyticsReports.vue";

export const analyticsRoutes = [
  {
    path: "analytics",
    name: "Country.Analytics.Main",
    component: AnalyticsGeneral,
    props: true,
    meta: {
      title: t("main_router.aval"),
      renderInMenu: true,
      menuName: "analytics",
    },
  },
  {
    path: "reports",
    name: "Country.Analytics.Reports",
    props: true,
    component: AnalyticsReports,
    meta: {
      title: t("main_router.aval"),
      renderInMenu: true,
      menuName: "analytics_report",
    },
  }
];
